<template>
  <VFiltersPopup
    popup-class="demandsv2-outer-filter"
    :title-list="titleList"
    @submit="applyFilters"
    @clear="clearFilters"
  >
    <section class="outer-filter-container">
      <VButtonGroup>
        <VButton
          :theme="draft.isMine ? 'primary' : 'default'"
          @click="draft.isMine = true"
        >
          <template #icon>
            <VIcon material="person_black" />
          </template>
          <slot name="label-mine">
            Мои потребности
          </slot>
        </VButton>
        <VButton
          :theme="draft.isMine ? 'default' : 'primary'"
          @click="draft.isMine = false"
        >
          <template #icon>
            <VIcon material="filter_alt" />
          </template>
          <slot name="label-all">
            Все потребности
          </slot>
        </VButton>
      </VButtonGroup>

      <div class="wrap">
        <VSelectV2
          v-model="draft.responsible"
          class="responsible-input"
          placeholder="Ответственный"
          :disabled="draft.isMine"
          :data="({ pattern }) => PersonsService.searchPersons(pattern, currentPartnerId)"
        />
      </div>
    </section>
  </VFiltersPopup>
</template>

<style src="./DemandsV2PageFilter.scss" />

<script lang="ts">
import VFiltersPopup from '@/components/VFiltersPopup/VFiltersPopup.vue';
import PersonsService from '@/domains/Persons/PersonsService';
import PartnersService from '@/domains/Partners/PartnersService';
import OrdersPageFilter from "@/domains/Orders/components/OrdersFlow/OrdersPageFilter/OrdersPageFilter";
import DemandsV2PageFilter
  from "@/domains/DemandsV2/components/DemandsV2Page/DemandsV2PageFilter/DemandsV2PageFilter";

export default defineComponent({
  name: 'DemandsV2PageFilterComponent',

  components: {
    VFiltersPopup,
  },

  props: {
    filters: {
      type: Object as PropType<OrdersPageFilter>,
      required: true,
    },
  },

  emits: [DemandsV2PageFilter.Events.Updated],

  data() {
    return {
      PersonsService,
      PartnersService,

      // Draft - черновик для редактирования
      draft: this.$core.utils.cloneDeep(this.filters),
    };
  },

  computed: {
    titleList(): string[] {
      const texts: string[] = [];

      if (this.filters.isMine) {
        texts.push('Мои потребности');
      } else {
        if (this.filters.responsible) {
          texts.push(this.filters.responsible.name);
        } else {
          texts.push('Все потребности');
        }
      }

      return texts;
    },

    currentPartnerId() { return this.$core.currentPartner!.id },
  },

  methods: {
    applyFilters() {
      this.draft.apply();

      this.$emit(DemandsV2PageFilter.Events.Updated, this.draft);

      // Создаём новый draft для следующего редактирования
      this.draft = this.$core.utils.cloneDeep(this.draft);
    },

    clearFilters() {
      // Сбрасываем filters
      this.filters.reset();

      // Создаём новый draft из сброшенного filters
      this.draft = this.$core.utils.cloneDeep(this.filters);

      // Эмитим родителю
      this.$emit(DemandsV2PageFilter.Events.Updated, this.filters);
    },
  },
});
</script>
